<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <!-- Users -->
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <billing-rules></billing-rules>
              </div>
            </div>
            <!-- end card -->
          </div>
        </div>
        <!-- end row -->
    </Layout>
</template>

<script>

import Vue from 'vue';
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import BillingRules from "../components/admin/billingRules.vue";
import appConfig from "@/app.config";
import routes from '../../../routes.js';
// import Swal from "sweetalert2";
import VueToast from 'vue-toast-notification';
// Import one of the available themes
import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(VueToast);

// import {getFieldTicketForm, getFieldTypes} from '../helper/dbHelpers.js';
// import { firestore } from 'firebase';

export default {
    page: {
        title: "Billing Rules",
        meta: [{ name: "Billing Rules", content: appConfig.description }]
    },
    components: { 
        Layout, 
        PageHeader,
        BillingRules
    },
    data() {
        return {
            title: 'Billing Rules',
            name: 'Billing Rules',
            items: [
                {
                    text: "home",
                    href: '/'
                },
                {
                    text: 'billing rules',
                    href: '/production/admin',
                    active: true
                }
            ],
            routes: routes,
            
            
            // addField_name: null,
            // addField_label: null,
            // addField_type: null,
            // addField_mobile: null,
            // addField_web: null,
            // addField_required: null,
            // addField_selectedType: [],
            // addField_errors:{
            //   nameError: false,
            //   nameMessage: null,
            //   labelError: false,
            //   labelMessage: null,
            //   typeError: false,
            //   typeMessage: null,
            // },
            // editField_index: null,
            // editField_order: null,
            // editField_name: null,
            // editField_label: null,
            // editField_mobile: null,
            // editField_web: null,
            // editField_required: null,
            // editField_selectedType: [],
            // editField_errors:{
            //   nameError: false,
            //   nameMessage: null,
            //   labelError: false,
            //   labelMessage: null,
            //   typeError: false,
            //   typeMessage: null,
            // },
            // fieldTypes: [],
            // formDocID: null,
            // nonDeleteFields: ['Date', 'Hours', 'Employee', 'Rate', 'Description']
        }
    },
    methods: {
    },
    mounted() {
    }
}
</script>